import { AnyAction } from "redux";

import { myFleetActions } from "../reducer/reducer";
import { WorkDisplay } from "features/myFleet/types";

export const setActiveDisplay = (activeDisplay: WorkDisplay): AnyAction =>
  myFleetActions.setActiveDisplay(activeDisplay);
